// Research Areas — three thematic clusters from VITA and research profile (verified).
// Order and titles per stakeholder direction (Webpage Notes 260512).

export const researchAreas = [
  {
    id: "ra1",
    title: "Discourse Analysis",
    description:
      "Discourse analysis that moves beyond the single speech event to examine how identity and meaning accumulate across interactions over time, including longitudinal trajectory analysis.",
  },
  {
    id: "ra2",
    title: "Social Identification and Learning",
    description:
      "The joint emergence of social identity and cognitive learning in classrooms — how becoming a student and becoming a certain kind of person happen together, not separately.",
  },
  {
    id: "ra3",
    title: "New Latino Diaspora",
    description:
      "Identity, language ideology, and education for Mexican immigrant families in non-traditional US settlement regions — communities without existing infrastructure for receiving newcomers.",
  },
];
